module.exports = __webpack_public_path__ + "no-opinions.a04d47655ce10c624b4926d2052d4716.png";